/* eslint-disable for-direction */
/* eslint-disable semi-style */
/* eslint-disable lines-between-class-members */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable function-paren-newline */
/* eslint-disable no-buffer-constructor */
/* eslint-disable getter-return */
/* eslint-disable switch-colon-spacing */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
/* eslint-disable import/no-unresolved */
/* eslint-disable  no-undef */

import bugsnag from 'bugsnag-js';
import bugsnagVue from 'bugsnag-vue';
import Vue from 'vue';
import VueYoutube from 'vue-youtube';
import VModal from 'vue-js-modal';
import App from './App';
import router from './router';

let env = process.env.NODE_ENV;
// let fbid = '';
if (env === 'production') {
    // fbid = '';
    if ((window.location.hostname).includes('staging')) {
        env = 'staging';
    // fbid = '';
    } else if ((window.location.hostname).includes('sandbox')) {
        env = 'sandbox';
    // fbid = '';
    }
}

const bugsnagClient = bugsnag({
    apiKey: '879d4e990551dc88dd6c7d366f71413a',
    releaseStage: env,
    notifyReleaseStages: ['production', 'sandbox', 'staging'],
});
bugsnagClient.use(bugsnagVue(Vue));

Vue.use(VueYoutube);
Vue.use(VModal);
Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    components: {
        App,
    },
    template: '<App/>',
});



// WEBPACK FOOTER //
// ./src/main.js